import { render } from "./WorkoutTypes.vue?vue&type=template&id=8442cd64&scoped=true"
import script from "./WorkoutTypes.vue?vue&type=script&lang=js"
export * from "./WorkoutTypes.vue?vue&type=script&lang=js"

import "./WorkoutTypes.vue?vue&type=style&index=0&id=8442cd64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8442cd64"]])

export default __exports__